"use strict";

exports.__esModule = true;

var _crmWixcodeJsCommons = require("@wix/crm-wixcode-js-commons");

exports.contacts = _crmWixcodeJsCommons.contacts;
exports.members = _crmWixcodeJsCommons.members;
//# sourceMappingURL=platformizedEndpointsUtils.js.map